<template>
  <div class="home">
    <!-- 모바일: 이미지 + CTA -->
    <MobileImageSection v-if="isMobile" @open-form="$emit('open-form')" />
    
    <!-- PC: 배너 섹션 -->
    <BannerSection v-else />
  </div>
</template>

<script>
import BannerSection from '@/components/home/BannerSection.vue'
import MobileImageSection from '@/components/mobile/MobileImageSection.vue'

export default {
  name: 'HomeView',
  components: {
    BannerSection,
    MobileImageSection
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open-form']
}
</script>

<style scoped>
.home {
  width: 100%;
}
</style>